module.exports = __webpack_public_path__ + "img/paifeng01.14b12e64.png";